import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/docs/roles")({
	component: Roles,
});

function Roles() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-semibold tracking-[-0.04em]">
					Roles and permissions
				</h1>
				<p className="text-sm text-muted-foreground">
					What each workspace role can do.
				</p>
			</div>

			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<ul className="list-disc pl-5 space-y-3">
					<li>
						<strong className="text-foreground">Owner</strong> has full access.
						Can manage workspace settings, billing, connections, and members.
						Can delete the workspace.
					</li>
					<li>
						<strong className="text-foreground">Member</strong> can create,
						edit, schedule, and delete posts. Cannot change workspace settings
						or manage billing.
					</li>
				</ul>
				<p>
					The workspace creator is automatically an Owner. You need at least one
					Owner per workspace.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Managing roles
				</h2>
				<p>
					Owners can change a member&apos;s role or remove them from the
					workspace at any time from the{" "}
					<strong className="text-foreground">Members</strong> page.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/inviting-members"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Inviting members
				</Link>
				<Link
					to="/docs/connecting-accounts"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Connecting accounts &rarr;
				</Link>
			</div>
		</article>
	);
}
